import React from 'react';
import './card1.css';

const Card1 = (props) => {
    return ( 
        <>
        <div className="listing">
            <img src={props.listingImg} alt="book club icon" />
            <h4 className='body'>{props.listingTitle}</h4>
            <h5 className='body'>{props.listingDesc}</h5>
        </div>
        </>
     );
}
 
export default Card1;